<template>
  <v-app-bar :height="toolbarHeight"
             :max-height="toolbarHeight"
             flat
             color="white"
             class="main-app-bar">
    <template v-if="$vuetify.breakpoint.mdAndDown">
      <v-toolbar-title>
        <router-link :to="logoClick">
          <v-img src="/static/logo-b2-dark-text.svg" width="102" :height="toolbarHeight" contain />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="$store.dispatch('toggleShowDrawer')"></v-app-bar-nav-icon>
    </template>
    <template v-else>
      <v-toolbar-title :class="{ 'mr-12' :  userIsAuthenticated }">
        <router-link :to="logoClick">
          <v-img width="124" src="/static/logo-b2-dark-text.svg" :height="toolbarHeight" contain />
        </router-link>
      </v-toolbar-title>
      <v-spacer v-if="!userIsAuthenticated"></v-spacer>
      <v-btn v-for="item in menuItems"
             v-if="item.visible"
             :key="item.title"
             :to="item.link"
             large
             outlined
             tile
             color="color-new-link-blue"
             class="mx-3 navigation-button">
        {{item.title}}
      </v-btn>
      <v-spacer v-if="userIsAuthenticated  || initializing"></v-spacer>
      <template v-if="userIsAuthenticated">
        <div >
          <v-btn @click.stop="startContact"
                 dark
                 large
                 tile
                 color="primary"
                 class="mx-3 contact-button">
            <v-icon size="1.5rem" left class="mr-3">fas fa-comments</v-icon>
            {{ $t('menu.contact') }}
          </v-btn>
        </div>
      </template>
      <template v-if="userIsAuthenticated && !hidePersonalInfo && hasJPVActiveDebtorNr">
        <v-divider vertical v-if="userIsAuthenticated"></v-divider>
        <div>
          <v-btn to="/profile"
                 text
                 large
                 class="mx-3">
            <v-icon size="1.5rem" left color="color-new-body-grey" class="mr-3">fas fa-user-circle</v-icon>
            {{ $t('menu.profile') }}
          </v-btn>
        </div>
      </template>
      <v-divider vertical :class="{ 'ml-6' :  !userIsAuthenticated }" />
      <v-app-bar-nav-icon class="mr-1 ml-5" @click="$store.dispatch('toggleShowDrawer')"></v-app-bar-nav-icon>

    <v-dialog v-model="contactDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth">
      <shared-contact-dialog ref="contactDialog" @close="contactDialog = false"></shared-contact-dialog>
    </v-dialog>
    </template>
  </v-app-bar>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data: function () {
      return {
        isScrolled: false,
        contactDialog: false,
      }
    },
    computed: {
      ...mapGetters({
        userIsAuthenticated: 'authenticated',
        languages: 'languages',
        hidePersonalInfo: 'hidePersonalInfo',
        hasJPVActiveDebtorNr: 'hasJPVActiveDebtorNr',
        initializing: 'initializing',
        hasOnlyOneDebt: 'hasOnlyOneDebt'
      }),
      toolbarHeight () {
        return this.$vuetify.breakpoint.smAndDown ? '64px' : '88px'
      },
      logoClick () {
        if (this.userIsAuthenticated) {
          return '/front-page'
        } else {
          return '/'
        }
      },
      menuItems () {
        let menuItems = [
          { icon: 'fas fa-sign-in-alt', title: this.$t('login'), link: '/', visible: true },
          { icon: 'fas fa-question-circle', title: this.$t('menu.help'), link: '/help', visible: true }
        ]
        if (this.userIsAuthenticated) {
          menuItems = [
            { icon: 'fas fa-home', title: this.$t('menu.frontPage'), link: '/front-page', visible: true },
            { icon: 'fas fa-credit-card', title: this.$t('menu.payments'), link: '/payments', visible: this.hasMultipleDebts },
            { icon: 'fas fa-question-circle', title: this.$t('menu.help'), link: '/help', visible: true }
          ]
        }
        return menuItems
      },
      hasMultipleDebts () {
        if (this.userIsAuthenticated && !this.hasOnlyOneDebt) {
          return true
        } else {
          return false
        }
      },
      dialogSettings() {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1024px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      }
    },
    methods: {
      onLogout () {
        this.$store.dispatch('logout')
        window.localStorage.clear()
        this.$router.push('/')
      },
      startContact () {
        this.contactDialog = true;
        this.$nextTick(() => {
          this.$refs.contactDialog.setDefaultDebt();
        });
        this.$matomo && this.$matomo.trackEvent("Action", "Send Message", "Send Message Start")
      }
    }
  }
</script>

<style>
  .main-app-bar .v-toolbar__content {
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: solid 1px #0000001f;
  }
</style>
